export const SUPPORTED_LANGUAGES = ['js', 'jsx', 'ts', 'tsx', 'html'];
export const NON_VISUAL_LANGUAGES = ['js', 'ts'];
export const getCompilationKey = (source, language) => ['codeCompilation', source, language];
//# sourceMappingURL=compilation.js.map